export const SOIL_MOISTURE_NAME = 'Humedad Suelo';

export const WIND_NAME = 'Viento';

export const SALINITY_NAME = 'Salinidad';

export const SOIL_TEMPERATURE_NAME = 'Temperatura de suelo';

export const ROOTS_NAME = 'Profundidad de Riego';

export const IRRIGATION_NAME = 'Riego';

export const STACKED_SOIL_MOISTURE_NAME = 'Humedad Suelo Apilado';

export const KC_NAME = 'Kc';

export const ET0_NAME = 'ET0';

export const PRECIPITATION_NAME = 'Precipitaciones';

export const PLANTS_NAME = 'Dendrometro de brote';

export const HUMIDITY_TEMPERATURE_NAME = 'temperatura-humedad';

export const TEMPERATURE_NAME = 'Temperatura';

export const HUMIDITY_NAME = 'Humedad';

export const COLD_HOURS_NAME = 'Horas Frío';

export const CHILL_PORTIONS_NAME = 'Porciones de Frío';

export const DEGREE_DAY_NAME = 'Grados Día';

export const PH_ELECTRICITY_NAME = 'PH y conductividad de suelo';

export const RADIATION_NAME = 'Radiación solar';

export const DPV_NAME = 'DPV';

export const ET0_IRRIGATION_NAME = 'ETo + Riego';

// Clase CSS de las bandas de ciclo fenológico (hover-reveal en los Highcharts).
export const PHENOLOGY_BAND_CLASS = 'cdtec-phenology-cycle-band';

// Títulos de gráficos — valor por defecto de la prop `title` en cada chart component.
export const CHART_TITLE_KC = 'Gráfico Kc';
export const CHART_TITLE_ETO = 'Gráfico ETo';
export const CHART_TITLE_RIEGO = 'Gráfico de Riego';
export const CHART_TITLE_ETO_RIEGO = 'Gráfico de Eto + Riego';
export const CHART_TITLE_PRECIPITACIONES = 'Gráfico de Precipitaciones';
export const CHART_TITLE_VIENTO = 'Gráfico de Viento';
export const CHART_TITLE_DPV = 'Gráfico DPV';
export const CHART_TITLE_SALINIDAD_APILADA = 'Gráfico de salinidad de suelo apilada';
export const CHART_TITLE_RADIACION = 'Gráfico de radiación solar';
export const CHART_TITLE_HUMEDAD_TEMPERATURA = 'Gráfico de temperatura y humedad';
export const CHART_TITLE_HUMEDAD_SUELO = 'Gráfico de humedad suelo';
export const CHART_TITLE_PH_CONDUCTIVIDAD = 'Gráfico PH y conductividad de suelo';
export const CHART_TITLE_HUMEDAD_SUELO_APILADO = 'Gráfico de humedad de suelo apilado';
export const CHART_TITLE_PLANTAS = 'Gráfico de Plantas';
export const CHART_TITLE_TEMPERATURA_SUELO = 'Gráfico de temperatura de suelo';
export const CHART_TITLE_HORAS_FRIO_ACUMULADAS = 'Gráfico Horas Frío Acumuladas';
export const CHART_TITLE_PORCIONES_FRIO_ACUMULADAS = 'Gráfico Porciones de Frío Acumuladas';
export const CHART_TITLE_GRADOS_DIA = 'Gráfico de Grados Día';
export const CHART_TITLE_PROFUNDIDAD_RIEGO = 'Gráfico de Profundidad de Riego';

// Títulos cortos — overrides pasados desde vistas (dashboard y reporte quincenal).
export const CHART_TITLE_SECTOR_HUMEDAD_SUELO = 'Humedad de suelo';
export const CHART_TITLE_SECTOR_PROFUNDIDAD_RAICES = 'Profundidad riego y raices';
export const CHART_TITLE_SECTOR_SUMATORIA_HUMEDAD = 'Sumatoria humedad suelo';
export const CHART_TITLE_WS_GRADOS_DIA = 'Grados Día';
export const CHART_TITLE_WS_HORAS_FRIO = 'Horas Frío Acumulada';
export const CHART_TITLE_BW_KC_MM = 'Kc y mm';
export const CHART_TITLE_BW_SUMATORIA_HUMEDAD = 'Sumatoria humedad de suelo';
export const CHART_TITLE_BW_PROFUNDIDAD_RAICES = 'Profundidad riego y raíces';
export const CHART_TITLE_BW_DENDROMETRO = 'Dendrómetro';
export const CHART_TITLE_BW_HUMEDAD_TEMPERATURA = 'Humedad y temperatura';
export const CHART_TITLE_BW_SALINIDAD = 'Salinidad';
export const CHART_TITLE_BW_TEMPERATURA_SUELO = 'Temperatura del suelo';
export const CHART_TITLE_BW_HORAS_FRIO = 'Horas frío';
export const CHART_TITLE_BW_GRADOS_DIA = 'Grados día';
